export default "__VITE_ASSET__BdoY00bA__"